import React from "react";
import { Dialog, DialogContent, IconButton, styled } from "@mui/material";
import { ControlledSelect, ControlledTextField } from "../../components/inputs";
import { CloseSharp } from "@mui/icons-material";
import { Grid } from "@mui/material";
import { Form, Title, Button, MenuItem } from "../../components";
import DateTextField from "../../components/inputs/DateTextField";
import { captureConsoleIntegration } from "@sentry/react";

const StyledDialog = styled(Dialog)`
  & .MuiPaper-root {
    width: 100%;
  }
`;
const CloseIconButton = styled(IconButton)`
  position: absolute;
  top: 0;
  right: 0;
`;

const getInputProps = (type) => {
  switch (type) {
    case "date":
      return {
        inputComponent: DateTextField,
      };
    case "object":
      return null;
    case "text":
    default:
      return {
        maxLength: 50,
      };
  }
};

const getInputComponent = ({ type, formProps, label, options, keys }) => {
  switch (type) {
    case "object":
      return (
        <ControlledSelect
          name={"input"}
          formProps={formProps}
          label={label}
        >
          {options?.map((state) => (
            <MenuItem key={state[keys?.id]} value={state[keys?.id]}>
              {keys?.label.map((element, index) => {
                if (index === 0) {
                  return state[element];
                } else {
                  return ` - ${state[element]}`;
                }
              })}
            </MenuItem>
          ))}
        </ControlledSelect>
      )
    case "date":
    case "text":
    default:
      return (
        <ControlledTextField
          formProps={formProps}
          name={"input"}
          label={label}
          InputProps={getInputProps(type)}
        />
      )
  }
}

const AlterarInputPropostaDialog = ({
  handleSubmit,
  submitting,
  handleClose,
  formProps,
  open,
  title = "Inserir Informação",
  label = "Campo",
  type,
  options,
  keys,
}) => {
  return (
    <StyledDialog
      onClose={() => { }}
      disableEscapeKeyDown
      maxWidth="xs"
      open={open}
    >
      <DialogContent>
        {!submitting && (
          <CloseIconButton onClick={handleClose}>
            <CloseSharp />
          </CloseIconButton>
        )}
        <Title as={"h2"} _margin_={"0 0 1rem 0"}>
          {title}
        </Title>
        <Form onSubmit={handleSubmit}>
          <Grid container>
            <Grid item xs={12}>
              {getInputComponent({ type, formProps, label, options, keys })}
            </Grid>
          </Grid>
          <Grid container justifyContent={"center"}>
            <Grid item xs={12} md={8}>
              <Button loading={submitting} type={"submit"} fullWidth>
                CONFIRMAR
              </Button>
            </Grid>
          </Grid>
        </Form>
      </DialogContent>
    </StyledDialog>
  );
};

export default AlterarInputPropostaDialog;
